import "core-js/modules/es.symbol";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.keys";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2017,2019. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */


import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import PanelHeader from './PanelHeader';
import { uniqueIdForComponent } from '../util';
var propTypes = {
  /** required only when `title` property is not supplied
   * Content will be used by assistive
   * technology to describe the contents of the Panel
   */
  ariaLabel: PropTypes.string,

  /** title of the Panel's header element */
  title: PropTypes.string,

  /** The heading level for the title for the panel header */
  titleHeadingLevel: PropTypes.oneOf(['1', '2', '3', '4', '5', '6']),

  /** specifies if the Panel should be bordered */
  bordered: PropTypes.bool,

  /** specifies if the Panel title should not have a border */
  titleBorderless: PropTypes.bool,

  /** specifies if the Panel title should be centered */
  titleCentered: PropTypes.bool,

  /** extra class name */
  className: PropTypes.string,

  /** children of the panel component */
  children: PropTypes.node.isRequired,

  /** make the panel component highlight when tab key is pressed */
  tabIndex: PropTypes.number,

  /** role to be used for accessibility purposes */
  role: PropTypes.string
};
var defaultProps = {
  bordered: false,
  titleBorderless: false,
  titleCentered: false,
  className: undefined,
  ariaLabel: undefined,
  title: undefined,
  titleHeadingLevel: '4',
  tabIndex: null,
  role: 'region'
};

var Panel = function Panel(_ref) {
  var bordered = _ref.bordered,
      className = _ref.className,
      children = _ref.children,
      tabIndex = _ref.tabIndex,
      titleBorderless = _ref.titleBorderless,
      titleCentered = _ref.titleCentered,
      ariaLabel = _ref.ariaLabel,
      title = _ref.title,
      titleHeadingLevel = _ref.titleHeadingLevel,
      role = _ref.role,
      otherProps = _objectWithoutProperties(_ref, ["bordered", "className", "children", "tabIndex", "titleBorderless", "titleCentered", "ariaLabel", "title", "titleHeadingLevel", "role"]);

  if (tabIndex) {
    if (!title && !ariaLabel) {
      console.error('Either title or ariaLabel property is mandatory for a Panel Component.');
    } else if (title && ariaLabel) {
      console.warn('Only one of title or ariaLabel properties must be set for a Panel Component. Title will take precedence.');
    }
  }

  var titleId = uniqueIdForComponent();
  var stylingClass = classnames('wds-c-panel', {
    'wds-c-panel--bordered': bordered
  }, className);
  return React.createElement("div", _extends({
    className: stylingClass
  }, title !== undefined ? {
    'aria-labelledby': titleId
  } : {
    'aria-label': ariaLabel
  }, {
    role: role,
    tabIndex: tabIndex
  }, otherProps), title && React.createElement(PanelHeader, {
    id: titleId,
    title: title,
    titleHeadingLevel: titleHeadingLevel,
    borderless: titleBorderless,
    centered: titleCentered
  }), children);
};

Panel.propTypes = propTypes;
Panel.defaultProps = defaultProps;
export default Panel;